import { render, staticRenderFns } from "./groupFinal1.vue?vue&type=template&id=bd100db4&scoped=true"
import script from "./groupFinal1.vue?vue&type=script&lang=js"
export * from "./groupFinal1.vue?vue&type=script&lang=js"
import style0 from "./groupFinal1.vue?vue&type=style&index=0&id=bd100db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd100db4",
  null
  
)

export default component.exports